import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export const AlertNotificationConstant: ltFramework.IAlertNotificationConstant = {
	alertNotificationPrefix: 'alert-notification-',
	alertNotificationSuccess: 'alert-success',
	alertNotificationInfo: 'alert-info',
	alertNotificationWarning: 'alert-warning',
	alertNotificationDanger: 'alert-danger',
	alertNotificationElementId: '.js-alert-notification',
	alertNotificationStudentId: 'studentFlexReactivation',
	alertNotificationOnHoldId: 'onHoldReactivation',
	alertNotificationStudentDismissed: 'lt-dismissed-student-reactivate-notification',
	alertNotificationOnHoldDismissed: 'lt-dismissed-onhold-reactivate-notification'
};

export const AlertNotificationModuleConstant: ltFramework.IAlertNotificationModuleConstant = {
	action: {
		initialize: 'initialize',
		open: 'open',
		close: 'close'
	},
	getter: {},
	mutation: {
		setAlertNotifications: 'setAlertNotifications',
		addAlertNotification: 'addAlertNotification',
		removeAlertNotification: 'removeAlertNotification'
	},
	name: 'alertNotificationModule',
	state: {
		alertNotifications: 'alertNotifications'
	}
};

export const ClubModuleConstant: ltFramework.IClubModuleConstant = {
	action: {
		initialize: 'initialize',
		initializeClub: 'initializeClub',
		updateClub: 'updateClub'
	},
	getter: {},
	mutation: {
		setClubDetails: 'setClubDetails',
		setInitializing: 'setInitializing'
	},
	name: 'clubModule',
	state: {
		clubDetails: 'clubDetails'
	}
};

export const ClubsModuleConstant: ltFramework.IClubsModuleConstant = {
	action: {
		initialize: 'initialize'
	},
	getter: {},
	mutation: {
		setClubs: 'setClubs'
	},
	name: 'clubsModule',
	state: {
		clubsList: 'clubsList'
	}
};

export const NearestClubModuleConstant: ltFramework.INearestClubModuleConstant = {
	action: {
		searchForNearestClubs: 'searchForNearestClubs'
	},
	getter: {},
	mutation: {
		setStore: 'setStore'
	},
	name: 'nearestClubModule',
	state: {
		store: 'store'
	}
};

export const RecentClubModuleConstant: ltFramework.IRecentClubModuleConstant = {
	action: {
		initialize: 'initialize',
		addRecentClub: 'addRecentClub'
	},
	getter: {},
	mutation: {
		setRecentClubs: 'setRecentClubs',
		addRecentClub: 'addRecentClub'
	},
	name: 'recentClubModule',
	state: {
		store: 'store'
	}
};

export const EmployeeProfileModuleConstant: ltFramework.IEmployeeProfileModuleConstant = {
	action: {
		initialize: 'initialize',
		logout: 'logout'
	},
	getter: {},
	mutation: {
		setEmployeeProfile: 'setEmployeeProfile'
	},
	name: 'employeeProfileModule',
	state: {
		employeeProfile: 'employeeProfile'
	}
};

export const ExperienceTypeConstant: ltFramework.IExperienceTypeConstant = {
	employee: 'employee',
	member: 'member',
	prospect: 'prospect',
	sport: 'sport',
	work: 'work',
	workProspect: 'work-prospect',
	rare: 'rare',
	living: 'living'
};

export const NavigationModuleConstant: ltFramework.INavigationModuleConstant = {
	action: {
		initialize: 'initialize'
	},
	getter: {},
	mutation: {
		setNavigation: 'setNavigation'
	},
	name: 'navigationModule',
	state: {
		navigation: 'navigation'
	}
};

export const EmployeeStateConstant: ltFramework.IEmployeeStateConstant = {
	unknown: 'UNKNOWN',
	authenticated: 'AUTHENTICATED',
	unauthenticated: 'UNAUTHENTICATED'
};

export const EventConstant: ltFramework.IEventConstant = {
	efFrameworkLoaded: 'ef-framework-loaded'
};

export const CookieConstant: ltFramework.ICookieConstant = {
	aemToken: 'login-token',
	customerToken: 'lt-customer-token',
	aemTokenExpires: 0, // session cookie
	lastVisited: 'lt-last-visited-page',
	lastVisitedLocation: 'lt-last-visited-location',
	ltSession: 'lt-session',
	profileToken: 'ltf-profile',
	jwtToken: 'lt-tm-jwt-cookie',
	roles: 'lt-tm-roles',
	rolesExpires: 0, // session cookie
	employeeDetails: 'lt-employee-details',
	profileTokenExpires: 6480000, // 75 days
	ssoId: 'LTFSSOIDCookie',
	tmSsoId: 'lt-tm-sso-cookie',
	ssoIdExpires: 0, // session cookie
	cookieLastVisited: 'lt-last-visited-page',
	ltAuthentication: 'lt-authentication',
	ltAuthorization: 'lt-authorization',
	ltSsoCreated: 'LTFSSO-created',
	ltDomainName: '.lifetime.life',
	authenticationExpires: 0 // session cookie
};

export const MemberStateConstant: ltFramework.IMemberStateConstant = {
	unknown: 'UNKNOWN',
	authenticated: 'AUTHENTICATED',
	unauthenticated: 'UNAUTHENTICATED',
	remembered: 'REMEMBERED'
};

export const MessageConstant: ltFramework.IMessageConstant = {
	expiredSsoMessage: 'Expired SSO Session.',
	invalidRequestMessage: 'Bad Request',
	profileNotFoundMessage: 'Profile does not exist.',
	timeout: 'timeout'
};

export const ProfileModuleConstant: ltFramework.IProfileModuleConstant = {
	action: {
		initialize: 'initialize',
		logout: 'logout',
		updateSchregSavedSearches: 'updateSchregSavedSearches'
	},
	getter: {},
	mutation: {
		setProfile: 'setProfile'
	},
	name: 'profileModule',
	state: {
		profile: 'profile'
	}
};

export const ProspectProfileModuleConstant: ltFramework.IProspectProfileModuleConstant = {
	action: {
		initialize: 'initialize',
		updateProspectClub: 'updateProspectClub'
	},
	getter: {},
	mutation: {
		setProspectProfile: 'setProspectProfile'
	},
	name: 'prospectProfileModule',
	state: {
		prospectProfile: 'prospectProfile'
	}
};

export const StorageConstant: ltFramework.IStorageConstant = {
	partyId: 'lt-party-id',
	memberDetails: 'lt-member-details',
	navigation: 'lt-tm-navigation',
	personalization: 'lt-personalization',
	alertNotifications: 'lt-alert-notifications',
	deferredAlertNotifications: 'lt-deferred-alert-notifications',
	dismissedAlertNotifications: 'lt-notification-display',
	clubData: 'lt-club-data',
	clubs: 'lt-clubs',
	recentClubs: 'lt-recent-clubs',
	ltPendingCancellation: 'lt-pending-cancellation',
	sessionItemPrefix: 'lt-session.'
};

export const AnalyticsConstant: ltFramework.IAnalyticsConstant = {
	marketingCloudInstanceId: 'A711776A5245B1150A490D44@AdobeOrg'
};

export const UrlModuleConstant: ltFramework.IUrlModuleConstant = {
	action: {
		initialize: 'initialize',
		updateUrl: 'updateUrl',
		urlUpdated: 'urlUpdated'
	},
	mutation: {
		setUrl: 'setUrl'
	},
	getter: {
		getGlobalPageDriverUrl: 'getGlobalPageDriverUrl'
	},
	name: 'urlModule',
	state: {
		url: 'url'
	}
};
